import { Box, Card, Icon, Typography } from "@drone-js/core";
import type { FunctionComponent } from "react";
import { HowManyToList } from "./constants";
import { useHowManyToListState } from "./howManyToListAtom";

interface Props {
    title: string;
    subtitle: string;
    value: HowManyToList;
    disabled?: boolean;
    dataElementName: string;
}

export const CardSelector: FunctionComponent<Props> = ({ subtitle, value, title, disabled, dataElementName }) => {
    const [selectedValue, setSelectedValue] = useHowManyToListState();

    const handleClick = () => {
        if (!disabled) setSelectedValue(value);
    };

    const isSelected = selectedValue === value;

    const villaIcon = (
        <Icon
            id={isSelected ? "fill.accommodation.villa" : "line.accommodation.villa"}
            size="32"
            color={isSelected ? "product.primary" : "base.default"}
        />
    );

    return (
        <Card
            type="interactive"
            variant="outlined"
            p="16"
            status={isSelected ? "selected" : "default"}
            onClick={handleClick}
            data-element-name={dataElementName}
        >
            <Box display="flex" gap="16" flexDirection="column">
                <Box
                    width="100%"
                    height="80px"
                    borderRadius="8"
                    backgroundColor="base.background"
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    flexShrink={0}
                    qM={{ width: "220px", height: "100px" }}
                >
                    <Icon id="fill.symbol.pin" size="20" color={isSelected ? "product.primary" : "base.default"} />
                    <Box pt="4" display="flex" gap="4">
                        {value === HowManyToList.Single ? (
                            villaIcon
                        ) : (
                            <>
                                {villaIcon}
                                {villaIcon}
                                {villaIcon}
                            </>
                        )}
                    </Box>
                </Box>
                <Box>
                    <Typography
                        variant="body-default-strong"
                        textColor={isSelected ? "product.primary" : "base.default"}
                    >
                        {title}
                    </Typography>
                    <Typography variant="body-s" textColor="base.subtle" mt="12">
                        {subtitle}
                    </Typography>
                </Box>
            </Box>
        </Card>
    );
};
